// Submission Status Constants

export interface StatusOption {
  value: string;
  label: string;
}

export const SUBMISSION_STATUS_OPTIONS: StatusOption[] = [
  { value: 'all', label: 'All' },
  { value: 'pending', label: 'Pending' },
  { value: 'processing', label: 'Processing' },
  { value: 'completed', label: 'Completed' },
  { value: 'failed', label: 'Failed' },
];

// Status values
export const SUBMISSION_STATUS = {
  ALL: 'all',
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

// Status display labels
export const SUBMISSION_STATUS_LABELS = {
  [SUBMISSION_STATUS.ALL]: 'All',
  [SUBMISSION_STATUS.PENDING]: 'Pending',
  [SUBMISSION_STATUS.PROCESSING]: 'Processing',
  [SUBMISSION_STATUS.COMPLETED]: 'Completed',
  [SUBMISSION_STATUS.FAILED]: 'Failed',
} as const;
